import Route from '@ember/routing/route';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { EMBER_ROUTE_NAMES } from 'sh-www/constants/routes';
import { trackPageViewFromTransition } from 'sh-www/utils/datalayer';
import { showModal } from 'sh-www/utils/modal-controls';
import { PROJECT_DETAILS__SUB_NAV_TITLES } from 'sh-www/constants/routes/project-details';

class ProjectDetailsActivityRoute extends Route {
  @service('commands/application-commands') applicationCommandService;
  @service router;

  /**
   * @inheritDoc
   */
  activate(transition) {
    super.activate(...arguments);
    trackPageViewFromTransition(this, transition, '/project/:id/activity/');
    this.controllerFor('project-details').updateSubNavState(PROJECT_DETAILS__SUB_NAV_TITLES.ACTIVITY);
  }

  @action
  willTransition(transition) {
    if (transition.isAborted) {
      return;
    }

    const projectDetailsController = this.controllerFor('project-details');
    const { application } = projectDetailsController;
    if (
      (projectDetailsController.newActivityMessage || projectDetailsController.hasUploadsInActivityRoute)
      && transition.targetName !== EMBER_ROUTE_NAMES.PROJECT__DETAILS__ACTIVITY
    ) {
      const modalModel = {
        actionButtonText: 'Leave',
        cancelButtonText: 'Cancel',
        isShowCancelButton: true,
        titleText: 'Leave without sending message?',
        bodyText: 'You have an unsent message. If you continue, your message will be lost.',
        confirmAction: () => {
          projectDetailsController.set('newActivityMessage', '');

          /**
           * Quick fix to simply fake a lack of uploads when there actually might be.
           */
          projectDetailsController.setHasUploadsInActivityRoute(false);

          transition.retry();
        }
      };

      showModal(this, 'confirmation', modalModel);

      transition.abort();
    }

    if (
      transition.targetName === EMBER_ROUTE_NAMES.PROJECTS__INDEX
      && !application.isRead
    ) {
      transition.abort();

      this.applicationCommandService.markApplicationActivitiesViewed(
        application,
        projectDetailsController.initialMostRecentMessage
      ).then(() => {
        projectDetailsController.set('application.isRead', true);
      }).finally(() => {
        transition.retry();
      });
    }
  }
}

export default ProjectDetailsActivityRoute;
